<!-- Upload area - shown when no file is selected -->
<div *ngIf="!selectedFile" class="media-upload" (click)="onUploadClick()">
  <input
    type="file"
    id="mediaFileInput"
    #fileInput
    (change)="onFileSelected($event)"
    [accept]="acceptedTypes"
    style="display: none;" />
  <div class="media-upload-content">
    <div class="media-upload-button-section">
      <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.875 10.625V13.4583C14.875 13.8343 14.7257 14.195 14.4601 14.4601C14.195 14.7257 13.8343 14.875 13.4583 14.875H3.54167C3.16565 14.875 2.80497 14.7257 2.53991 14.4601C2.27433 14.195 2.125 13.8343 2.125 13.4583V10.625M11.6875 5.67708L8.5 2.125M8.5 2.125L5.3125 5.67708M8.5 2.125V10.625" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <span class="media-upload-text">{{ 'champion.dialog.upload.button' | translateLang }}</span>
    </div>
    <p class="media-upload-formats">{{ acceptedTypesLabel }}</p>
  </div>
</div>

<!-- File preview - shown when file is selected -->
<div *ngIf="selectedFile" class="media-file-preview">
  <div class="media-file-info">
    <div class="media-file-thumbnail" [class.uploading]="isUploading">
      <img *ngIf="!isVideo" [src]="filePreviewUrl" alt="Preview" />
      <video *ngIf="isVideo" [src]="filePreviewUrl" [muted]="true" [loop]="true" [autoplay]="false"></video>
      <div *ngIf="isUploading" class="media-file-overlay"></div>
    </div>
    <div class="media-file-details">
      <p class="media-file-name-text">{{ selectedFileName }}</p>
      <p class="media-file-size" *ngIf="fileSize">{{ fileSize }}</p>
    </div>
  </div>

  <div class="media-file-actions">
    <div class="media-file-status" [class.uploading]="isUploading" [class.uploaded]="!isUploading">
      <svg *ngIf="!isUploading" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.6667 3.5L5.25 9.91667L2.33333 7" stroke="#00A63E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <span>{{ isUploading ? ('champion.dialog.upload.uploading' | translateLang) : ('champion.dialog.upload.uploaded' | translateLang) }}</span>
    </div>
    <button type="button" class="media-file-remove" (click)="onRemoveFile()" aria-label="Remove file">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 4L4 12M4 4L12 12" stroke="#181818" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
  </div>
</div>
